import CryptoJS from 'crypto-js';

const secretKey = 'Mostranscareer';

export const encryptUrlParam = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return encodeURIComponent(encryptedData);
};

export const decryptUrlParam = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), secretKey);
    if (bytes) {
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
  } catch (error) {
    console.error('Error decrypting data:', error);
  }
  return null;
};
